import 'css-chunksrc/client/pages/projectPortfoliosPage/projectPortfolios/projectPortfolio/loader/styles.scss';export default {
  "loader": "_loader_1o6dv_1",
  "header": "_header_1o6dv_6",
  "addZoneButton": "_addZoneButton_1o6dv_15",
  "list": "_list_1o6dv_21",
  "item": "_item_1o6dv_28"
};